import {auth} from '../services';

/**
 * Middleware kiểm tra nếu client chưa login thì sẽ redirect đên page logic
 */
export default (payload, next) => {
    return auth.isLogged() ? next(payload) : auth.login();
};